import { Entity } from '@core/entities/entity'
import { IChecklistNominatedApprovers } from '@core/entities/checklist/ChecklistNominatedApprovers/IChecklistNominatedApprovers'
import { plainToInstance, Type } from 'class-transformer'
import { ChecklistNominateApprover } from '@core/entities/checklist/ChecklistNominateApprover'
import { SuggestedApprover } from '@core/entities/permit/SuggestedApprover'

// Nominated-approver state for a checklist's current approval step. Reuses the
// shared SuggestedApprover for the selectable list (mirror of permits).
export class ChecklistNominatedApprovers extends Entity<IChecklistNominatedApprovers> {
  @Type(() => ChecklistNominateApprover)
  approvers: Array<ChecklistNominateApprover>

  @Type(() => SuggestedApprover)
  suggestedApprovers: Array<SuggestedApprover>

  public static new(payload: unknown): ChecklistNominatedApprovers {
    const entity = plainToInstance(ChecklistNominatedApprovers, payload)

    return entity
  }
}
